<template>
    <div >
        <Header title="物流跟踪"></Header>

        <!-- {{this.$route.query.list}} -->
        <Scroll
        ref="wrapper"
        :listenScroll="false"
        :pullUpLoad="pullUpLoadObj"
        @pullingUp="onPullUpLoad"
        :pullDownRefresh="pullDownRefreshObj"
        @pullingDown="onPullDownRefresh"
      >
                <!-- {{list}} -->
                <div>
                    <van-steps :active="dataList.length" active-color="#e12020">
                        <van-step v-for="(item,index) in dataList" :key="index">{{item.nodeName}}</van-step>
                      </van-steps>

                      <van-steps active-color="#e12020" direction="vertical" :active="dataList.length">
                        <van-step v-for="(item,index) in dataList" :key="index">
                          <h3>[ {{item.nodeName}} ] {{item.remark}}</h3>
                          <p>{{tray(item.nodeTime)}}</p>
                        </van-step>
                      </van-steps>

                </div>
        </Scroll>
        <van-empty
        v-if="dataList.length<=0"
        class="custom-empty"
        description="暂无数据"
      ></van-empty>
    </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Scroll from "@/components/Scroll";
import transactionApi from "@/request/transactionApi";

export default {
    name:"Pickuplogistics",
    computed: {
        list:function (){
           return this.$route.query.list
        }
    },
    components: {
        Header,
        Scroll
    },
    data() {
        return{
            dataList:[]
        }
    },
    mounted() {
        this.gettrack()
    },
    methods: {
        gettrack(){
            var params={};
            params.billCode = this.$route.query.list.billNo;
            params.shipCode = this.$route.query.list.shipNo;
             transactionApi.gettrack(params).then((res) => {
                //  console.log(res)
                 this.dataList=res.result.nodeList;
             })
        },
        tray(date){
            // console.log(new Date(parseInt(date)))
            return new Date(parseInt(date)).toLocaleDateString();
        }
    }

}
</script>
<style lang="stylus">
    .Pickuplogistics{
        font-size: 90px;
    }
    .van-step--vertical{
        line-height:50px;
    }
    .van-step--horizontal{
        /* line-height:50px; */
    }
    .van-step__line{
        margin-top: 11px;
    }
    .van-step__circle-container{
        margin-top: 10px;
    }
</style>